import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueResource from 'vue-resource'

Vue.use(VueResource);

Vue.config.productionTip = false

new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js